<template>
  <section class="partner-programs">
    <header>
      <!-- <div class="search-box">
        <input v-model="searchQuery" type="search" placeholder="SEARCH">
        <span>
          <icon-search/>
        </span>
      </div> -->
      <h1>{{ $t('nav.partners') }}</h1>
    </header>
    <div class="programs">
      <div class="program" v-for="partner in partners" :key="partner.name">
        <span>{{ partner.name }}</span>
      </div>
    </div>
  </section>
</template>

<script>
// import IconSearch from '@/assets/images/icons/search_icon.svg'
import { GET_PARTNERS } from '@/store/actions.type'

export default {
  name: 'partner-programs',
  // components: {
  //   IconSearch 
  // },
  data() {
    return {
      searchQuery: ''
    }
  },
  computed: {
    partners() {
      const partners = this.$store.getters.partners.slice()
      return partners.sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
    }
  },
  created() {
    const loader = this.$loading.show()
    this.$store.dispatch(GET_PARTNERS).finally(() => {
      loader.hide()
    })
  }
}
</script>

<style lang="scss" scoped>
.search-box {
  display: flex;
  align-items: flex-end;
  float: right;
  width: 100%;
  max-width: 400px;

  span {
    display: inline-block;
    margin-bottom: em(7);
    max-width: 20px;
    max-height: 20px;

    svg {
      fill: currentColor;
    }
  }
}
.programs {
  margin: 30px 0 0 -25px;
  display: flex;
  justify-content: center;
}
.program {
  font-size: em(24);
  font-weight: 300;
  text-align: center;
  background-color: #fff;
  border: 2px solid #fff;
  display: block;
  margin-left: 25px;
  position: relative;
  width: 300px;
  height: 200px;
  transition: all 200ms;

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 90%;
    transform: translate(-50%, -50%);
  }
}
</style>
